import $ from 'jquery';

import './module/require-confirmation';
import SearchWidget from './module/search-widget';
import { promotionRulesAndActions } from './data/promotion-rules-and-actions';

(function () {
  $.fn.fileUpload = function () {
    var $this = $(this);
    var $uploadInput = $this.parent().find('input[type="file"]');
    var $textInput = $this.parent().find('input[type="text"]');
    var $uploadButton = $this.parent().find('button').not('.js__action-btn');

    $this.off('click');

    $uploadButton.on('click', function (e) {
      e.preventDefault();
      $uploadInput.prop('disabled', false);
      $uploadInput.trigger('click');
    });

    $textInput.on('click', function () {
      $uploadInput.trigger('click');
    });

    $uploadInput.on('change', function () {
      var path = $(this).val().split('\\').pop();
      $textInput.val(path);
    });
  };

  $.fn.visibleInScroll = function (goDeep) {
    var parent = $(this[0]).scrollParent()[0],
      elRect = this[0].getBoundingClientRect(),
      rects = [parent.getBoundingClientRect()];
    elRect = {
      left: elRect.left,
      top: elRect.top,
      right: elRect.right,
      bottom: elRect.bottom,
      width: elRect.width,
      height: elRect.height,
      visibleWidth: elRect.width,
      visibleHeight: elRect.height,
      isVisible: true,
      isContained: true,
    };
    var elWidth = elRect.width,
      elHeight = elRect.height;
    if (parent === this[0].ownerDocument) {
      return elRect;
    }

    while (parent !== this[0].ownerDocument && parent !== null) {
      if (parent.scrollWidth > parent.clientWidth || parent.scrollHeight > parent.clientHeight) {
        rects.push(parent.getBoundingClientRect());
      }
      if (rects.length && goDeep) {
        break;
      }
      parent = $(parent).scrollParent()[0];
    }
    if (!goDeep) {
      rects.length = 1;
    }
    for (var i = 0; i < rects.length; i += 1) {
      var rect = rects[Number(i)];
      elRect.left = Math.max(elRect.left, rect.left);
      elRect.top = Math.max(elRect.top, rect.top);
      elRect.right = Math.min(elRect.right, rect.right);
      elRect.bottom = Math.min(elRect.bottom, rect.bottom);
    }
    elRect.visibleWidth = Math.max(0, elRect.right - elRect.left);
    elRect.visibleHeight = elRect.visibleWidth && Math.max(0, elRect.bottom - elRect.top);
    if (!elRect.visibleHeight) {
      elRect.visibleWidth = 0;
    }
    elRect.isVisible = elRect.visibleWidth > 0 && elRect.visibleHeight > 0;
    elRect.isContained = elRect.visibleWidth === elRect.width && elRect.visibleHeight === elRect.height;
    return elRect;
  };

  const notFoundMessage =
    '<div class="message empty"><div class="header"><b>No Results</b></div><div class="description">Your search returned no results</div></div>';
  $.fn.dropdown.settings.message.noResults = notFoundMessage;

  $.fn.ajaxInput = function () {
    const $searchTermInput = $(this).find('.js__init-search-dropdown');
    let previousValue;
    let typingTimer;
    let isSpinnerVisible = false;
    const $resultDiv = $(this).find('.js__result-container');
    const dropdown = $(this);
    let isCalling = false;
    let scrollHeight = 0;
    let plusPage = 1;
    const url = $(this).data('url');
    const customer = $(this).data('customer');
    const type = $(this).data('type');

    $(this).dropdown({
      onChange: value => {
        const $searchInput = $(this).find('.js__init-search-dropdown');
        if (value) {
          const placeholderText = $searchInput.attr('placeholder');
          $searchInput.data('placeholder', placeholderText);
          $searchInput.attr('placeholder', '');
        } else {
          $searchInput.attr('placeholder', $searchInput.data('placeholder'));
        }
      },
    });

    function bindItems(dropdown) {
      dropdown.find('.item').on('click', function () {
        dropdown.prev().val($(this).data('value'));
      });
    }

    function setScrollParams(scrollContainer) {
      return scrollContainer.prop('scrollHeight');
    }

    function makeCall(currentPage, plusPage, searchKey, searchTerm, $dropdown) {
      $.ajax({
        url,
        method: $dropdown.data('method') || 'POST',
        data: {
          page: currentPage + plusPage,
          [searchKey]: searchTerm,
        },

        success(data) {
          $resultDiv.append(
            data.results.map(data => `<li class="item" data-value="${data.value}">${data.name}</li>`).join(''),
          );

          bindItems($dropdown);
          scrollHeight = setScrollParams($('.js__result-container'));
          isCalling = false;
        },
      });
    }

    function generateItems(data) {
      $resultDiv.html(data.map(data => `<li class="item" data-value="${data.value}">${data.name}</li>`).join(''));
    }

    function getResults(searchVal, $dropdown) {
      $dropdown.addClass('loading');
      const searchKey = $dropdown.data('search-key') || 'search';
      const data = { [searchKey]: searchVal };
      if (customer !== undefined) {
        data.customer = customer;
      }
      if (type !== undefined) {
        data.type = type;
      }
      $.ajax({
        url,
        method: $dropdown.data('method') || 'POST',
        data,
        beforeSend() {
          $resultDiv.html('');
        },

        success(data) {
          const $resultContainer = $('.js__result-container');
          $dropdown.removeClass('loading');

          if (data.results) {
            generateItems(data.results);
            bindItems($dropdown);

            scrollHeight = setScrollParams($resultContainer);

            $resultContainer.on('scroll', function () {
              if (scrollHeight * 0.5 < $(this).scrollTop() && data.hasNextPage && !isCalling) {
                isCalling = true;
                plusPage += 1;
                makeCall(data.currentPage, plusPage, searchKey, searchVal, $dropdown);
              }
            });
          } else if ($dropdown.data('full-array') && data.length) {
            generateItems(data);
            bindItems($dropdown);
          } else {
            $resultDiv.html(notFoundMessage);
            $dropdown.removeClass('loading');
            isSpinnerVisible = false;
          }
          setTimeout(() => {
            $dropdown.trigger('loaded', [data]);
          }, 200);
        },
      });
    }

    function typingLogic(dropdown) {
      if ($searchTermInput.val().trim() !== previousValue) {
        clearTimeout(typingTimer);

        if ($searchTermInput.val().trim() !== '') {
          if (!isSpinnerVisible) {
            dropdown.addClass('loading');
            isSpinnerVisible = true;
          }

          typingTimer = setTimeout(() => {
            getResults($searchTermInput.val().trim(), dropdown);
          }, 600);
        } else {
          $resultDiv.html('');
          isSpinnerVisible = false;
        }
      }
      previousValue = $searchTermInput.val();
    }

    $searchTermInput.on('keyup', () => {
      typingLogic(dropdown);
    });
  };

  $.fn.destroyDropdown = function () {
    return $(this).each(function () {
      $(this).parent().dropdown('destroy').replaceWith($(this));
    });
  };

  const addBundleProductPrices = ($target, price, priceWithDiscount) => {
    const $wrapper = $target.closest('[data-form-collection="item"]');
    $wrapper.find('.js__bundle-info').remove();

    if (!price) {
      return;
    }

    $(`
      <div class="ui segment spaceless grid js__bundle-info">
        <div class="two column row">
          <div class="column">
            <div>Bundle original price</div>
            <div>Bundle price with discount</div>
          </div>
          <div class="column">
            <div>${price / 100} Eur</div>
            <div><span class="js__product-price-with-discount">${
              priceWithDiscount / 100 || price / 100
            }</span> Eur</div>
          </div>
        </div>
        <div class="one column row js__discount-mismatch-error" style="display: none">
          <div class="column">
            <div class="ui info message">
                Sum off all discounts set for products in the bundle must be equal to difference of "Bundle original price" - "Bundle price with discount" of selected bundle product
            </div>
          </div>
        </div>
      </div>
    `).insertAfter($target);

    $wrapper.find('.js__product-code').each((index, element) => {
      const $element = $(element);
      $element
        .parent()
        .find('.js__product-name')
        .html(`${$element.data('product-name')} (${$element.val()})`);
    });

    const displayDiscountMismatchInfo = () => {
      const maxDiscount = (price - (priceWithDiscount || price)) / 100;
      const $errorMessage = $wrapper.find('.js__discount-mismatch-error');
      let discountSum = 0;

      $wrapper.find('.js__money-input').each((index, input) => {
        const $input = $(input);
        discountSum += Number($input.val() || 0);
      });

      $errorMessage.toggle(discountSum !== maxDiscount);
    };

    $('body').on('keyup', '.js__money-input', e => {
      displayDiscountMismatchInfo(e.currentTarget);
    });

    $wrapper.find('.js__discount-mismatch-error').each((index, element) => {
      displayDiscountMismatchInfo(element);
    });
  };

  const addBundleFixedDiscountActions = () => {
    $('.js__bundle-product-select').each((index, element) => {
      const $element = $(element);
      if (!$element.dropdown('get value')) {
        setTimeout(() => {
          $element.parent().parent().find('.js__price-config').parent().hide();
        }, 100);
      }
    });

    $('.js__bundle-product-select').on('change', e => {
      const $target = $(e.currentTarget);
      const $wrapper = $target.closest('[data-form-collection="item"]');
      const val = $target.dropdown('get value');
      const $dataElement = $target.find(`.js__bundle-data[data-value="${val}"]`).first();
      const data = $dataElement.data('data');

      if (!$dataElement.length) {
        return;
      }

      $target.parent().parent().find('.js__price-config').parent().show();

      $wrapper
        .find('div[id^="sylius_promotion_actions_"]')
        .first()
        .find('.button:not(.js__add-action)')
        .each((index, element) => {
          $(element).trigger('click');
        });

      addBundleProductPrices($target, data.price, data.priceWithDiscount);

      data.items.forEach(item => {
        $wrapper.find('.js__add-action').trigger('click');
        $wrapper.find('.js__product-name').last().html(`${item.name} (${item.code})`);
        $wrapper.find('.js__product-code').last().val(item.code);
        $wrapper.find('.js__product-id').last().val(item.id);
        $wrapper
          .find('.js__product-original-price')
          .last()
          .val(Math.round((item.originalPrice / 100) * 100) / 100);
      });
    });
  };

  /**
   * Collection Form plugin
   *
   * @param element
   * @constructor
   */
  var CollectionForm = function (element) {
    this.$element = $(element);
    this.$list = this.$element.find('[data-form-collection="list"]:first');
    this.count = this.$list.children().length;
    this.secondLevelCount = this.$list.children().length;

    const $collectionItemRow = this.$list.children().find('.js__collection-item-row').last();
    if ($collectionItemRow.length) {
      this.secondLevelCount = Number($collectionItemRow.attr('id').split('_').pop()) + 1;
    }

    this.lastChoice = null;
    this.updateInputValues = {};

    this.$element.on('click', '[data-form-collection="add"]:last', $.proxy(this.addItem, this));

    this.$element.on('click', '[data-form-collection="delete"]', $.proxy(this.deleteItem, this));

    this.$element.on('change', '[data-form-collection="update"]', $.proxy(this.updateItem, this));

    $(document).on('change', '[data-form-prototype="update"]', $.proxy(this.updatePrototype, this));

    $(document).on('collection-form-add', function (e, addedElement) {
      $(addedElement).find('[data-form-type="collection"]').CollectionForm();
      $(document).trigger('dom-node-inserted', [$(addedElement)]);
    });

    $('[data-form-collection="update"]').each((index, element) => {
      const $element = $(element);
      this.updateInputValues[$element.attr('name')] = $element.val();
    });

    if ($('.js__bundle-product-select').length) {
      addBundleFixedDiscountActions();
      $('.js__bundle-product-select').each((index, element) => {
        const $element = $(element);
        const $input = $element.find('input');
        addBundleProductPrices($element, $input.data('original-price'), $input.data('price-with-discount'));
      });
    }

    const $promotionConfiguration = $('.js__configuration');
    const valueSelect = $('.js__promotion-type').dropdown('get value');
    $promotionConfiguration
      .find('.dropdown:not(.js__ignore-options-filtering) > select > option')
      .each((index, element) => {
        if (
          promotionRulesAndActions[String(valueSelect)] &&
          !promotionRulesAndActions[String(valueSelect)].includes($(element).val())
        ) {
          $(element).attr('disabled', true).remove();
        }
      });
  };
  CollectionForm.prototype = {
    constructor: CollectionForm,

    /**
     * Add a item to the collection.
     * @param event
     */
    addItem: function (event) {
      event.preventDefault();

      var prototype = this.$element.data('prototype');
      var count = 0;

      prototype = prototype.replace(/__name__/g, this.count);
      const isInnerCollection = $(event.target)
        .closest('[data-form-type="collection"]')
        .parent()
        .closest('[data-form-type="collection"]').length;
      if (isInnerCollection) {
        prototype = prototype.replace(/__inner_name__/g, this.secondLevelCount);
        this.secondLevelCount = this.secondLevelCount + 1;
      } else {
        count = this.count;
      }

      var $promotionConfiguration = $('.js__configuration');
      var valueSelect = $('.js__promotion-type').dropdown('get value');
      if (valueSelect === 'coach') {
        setTimeout(function () {
          $('.js__action-widget-' + count)
            .find('select option[value="mgm_points_action"]')
            .prop('selected', true)
            .trigger('change');
          $('.js__action-widget-' + count)
            .find('select option')
            .not($('select option[value="mgm_points_action"]'))
            .hide();
        }, 300);
      }

      this.$list.append(prototype);
      if (!isInnerCollection) {
        this.count = this.count + 1;
      }

      var $lastElement = this.$list.children().last();
      $(document).trigger('collection-form-add', [$lastElement]);

      $promotionConfiguration.find('.dropdown:not(.js__ignore-options-filtering) > select > option').each(function () {
        if (
          promotionRulesAndActions[String(valueSelect)] &&
          !promotionRulesAndActions[String(valueSelect)].includes($(this).val())
        ) {
          $(this).attr('disabled', true).remove();
        }

        if (['group_of_products_discount', 'bundle_fixed_discount'].includes($(this).val())) {
          const $collection = $('[data-form-type="collection"]');
          $collection.CollectionForm();
        }
      });
    },

    /**
     * Update item from the collection
     */
    updateItem: function (event) {
      event.preventDefault();
      var $element = $(event.currentTarget),
        url = $element.data('form-url'),
        value = $element.val(),
        $container = $element.closest('[data-form-collection="item"]'),
        index = $container.data('form-collection-index'),
        position = $container.data('form-collection-index');

      if (url) {
        $container.load(url, { id: value, position: position });
      } else {
        var prototype = this.$element.find('[data-form-prototype="' + value + '"]').val();

        prototype = prototype.replace(/__name__/g, index);

        if (this.updateInputValues[$element.attr('name')] !== value) {
          $container.replaceWith(prototype);
        }
        SearchWidget.init();
      }
      $(document).trigger('collection-form-update', [$(event.currentTarget)]);
      var $promotionConfiguration = $('.js__configuration');
      var valueSelect = $('.js__promotion-type').dropdown('get value');

      const addCollectionFirsItemToActions = ['group_of_products_discount'];
      $promotionConfiguration.find('.dropdown:not(.js__ignore-options-filtering) > select > option').each(function () {
        if (
          promotionRulesAndActions[String(valueSelect)] &&
          !promotionRulesAndActions[String(valueSelect)].includes($(this).val())
        ) {
          if ($element.val() === $(this).val()) {
            const $dropdown = $(this).closest('.dropdown');
            let valueToSelect = '';
            $dropdown.find('option').each((index, element) => {
              const optionValue = $(element).val();
              if (!valueToSelect && promotionRulesAndActions[valueSelect].includes(optionValue)) {
                valueToSelect = optionValue;
              }
            });
            $dropdown.dropdown('refresh').dropdown('set selected', valueToSelect);
          }
          $(this).attr('disabled', true).remove();
        }

        if (addCollectionFirsItemToActions.includes(value)) {
          const $inputs = $('.js__action-widget').find('select[id*="sylius_promotion_actions_"]');

          $inputs.each((index, input) => {
            const $input = $(input);
            const inputVal = $input.val();
            const $list = $input.closest('.js__action-widget').find('[data-form-collection="list"]');
            if (addCollectionFirsItemToActions.includes(inputVal) && $list.children().length === 0) {
              $list.parent().find('.js__add-action').trigger('click');
            }
          });
        }

        if (['group_of_products_discount', 'bundle_fixed_discount'].includes($(this).val())) {
          const $collection = $('[data-form-type="collection"]');
          $collection.CollectionForm();
        }
      });

      $('[data-form-collection="update"]').each((index, element) => {
        const $element = $(element);
        this.updateInputValues[$element.attr('name')] = $element.val();
      });
    },

    /**
     * Delete item from the collection
     * @param event
     */
    deleteItem: function (event) {
      event.preventDefault();

      $(event.currentTarget).closest('[data-form-collection="item"]').remove();

      $(document).trigger('collection-form-delete', [$(event.currentTarget)]);

      var $promotionConfiguration = $('.js__configuration');
      var valueSelect = $('.js__promotion-type').dropdown('get value');

      $promotionConfiguration.find('.dropdown:not(.js__ignore-options-filtering) > select > option').each(function () {
        if (
          promotionRulesAndActions[String(valueSelect)] &&
          !promotionRulesAndActions[String(valueSelect)].includes($(this).val())
        ) {
          $(this).attr('disabled', true).remove();
        }
      });
    },

    /**
     * Update the prototype
     * @param event
     */
    updatePrototype: function (event) {
      var $target = $(event.currentTarget);
      var prototypeName = $target.val();

      if (undefined !== $target.data('form-prototype-prefix')) {
        prototypeName = $target.data('form-prototype-prefix') + prototypeName;
      }

      if (null !== this.lastChoice && this.lastChoice !== prototypeName) {
        this.$list.html('');
      }

      this.lastChoice = prototypeName;

      this.$element.data('prototype', this.$element.find('[data-form-prototype="' + prototypeName + '"]').val());
    },
  };

  /*
   * Plugin definition
   */

  $.fn.CollectionForm = function CollectionFormPlugin(option) {
    this.each((index, el) => {
      const $element = $(el);
      const data = $element.data('collectionForm');
      const options = typeof option === 'object' && option;

      if (!data) {
        $element.data('collectionForm', new CollectionForm(el, options));
      }
    });
  };

  $.fn.CollectionForm.Constructor = CollectionForm;

  $.fn.customerDeviceModal = function (deviceParent) {
    $(this)
      .modal({
        onVisible: function () {
          $('.js__set-value').on('click', function () {
            $('.ui.loadable.form').removeClass('loading');

            deviceParent.find('.js__init-ajax-select .text').text('');
            deviceParent.find('.js__submit-input').val($(this).data('id'));
            deviceParent.find('.js__init-ajax-select input').val($(this).data('value'));

            $('.js__device-modal').modal('hide');
          });
        },

        onHidden: function () {
          $('.js__set-value').off('click');
          $('.ui.loadable.form').removeClass('loading');
        },
      })
      .modal('show');
  };
})();
